import React from "react";

interface NotesIconProps {
  className?: string;
  onClick?: () => void;
}

export const NotesIcon = ({ className, onClick }: NotesIconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
    id="notes-icon-wt"
  >
    <path
      d="M27.875 23.5195V14.0625C27.875 13.1484 27.1016 12.375 26.1875 12.375H13.8125C12.8633 12.375 12.125 13.1484 12.125 14.0625V26.4375C12.125 27.3867 12.8633 28.125 13.8125 28.125H23.2344C23.6914 28.125 24.1133 27.9492 24.4297 27.6328L27.3477 24.7148C27.6641 24.3984 27.875 23.9766 27.875 23.5195ZM23.6211 26.8594C23.5508 26.9297 23.4453 26.9648 23.375 27V23.625H26.7148C26.6797 23.7305 26.6445 23.8359 26.5742 23.9062L23.6211 26.8594ZM26.75 14.0625V22.5H23.0938C22.6016 22.5 22.25 22.8867 22.25 23.3438V27H13.8125C13.4961 27 13.25 26.7539 13.25 26.4375V14.0625C13.25 13.7812 13.4961 13.5 13.8125 13.5H26.1875C26.4688 13.5 26.75 13.7812 26.75 14.0625Z"
      fill="black"
    />
  </svg>
);

NotesIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
